/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Divider, Drawer, IconButton, Step, StepLabel, Stepper, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import { LoadingPage } from "../../../common/LoadingPage";
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { apiRequest } from "../../../common/common";
import ProductDetails from "../Project/Items/ProductDetails";
import CommonDestination from "../Project/Items/CommonDestination";
import { ActionStage, ItemStatus, Scope } from "../../../common/const";
import { useSelector } from "react-redux";

const steps = ['Choose/Review Destination(s)', 'Item Details'];

const DemoBox1 = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 5px 5px 15px'
}));

const AddItemInProject = ({
    catalogOpen,
    setCatalogOpen,
    selectedData,
    setSelectedData,
    fromTemplate,
    innerLabel,
}) => {
    const { user } = useSelector(state => state.users);
    const [item, setItem] = useState({});
    const [tableData, setTableData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [projectData, setProjectData] = useState({});

    const handleClose = () => {
        setCatalogOpen(false);
        if (setSelectedData) {
            if (fromTemplate) {
                setSelectedData(null);
            } else {
                setSelectedData([]);
            }
        }
        setItem(null);
        setActiveStep(0);
    }

    const handleSubmit = async () => {
        if (tableData?.length > 0) {
            setDataLoading(true);
            try {
                if (fromTemplate) {
                    if (innerLabel === 'Item') {
                        item.room_data = JSON.stringify(
                            tableData?.map((a) => ({
                                room_id: a.room_id,
                                quantity: a.quantity || 1
                            }))
                        );
                        item.item_template_ids = selectedData;
                        item.project_id =  projectData.project_id;
                        const response = await apiRequest('post', '/project-item/from-template', item);
                        if (response.data) {
                            handleClose();
                            showNotification('The items have been successfully added to the selected rooms.', 'success');
                        }
                    } else if (innerLabel === 'Department') {
                        item.template_ids = [...new Set(selectedData.map((a) => a.dept_template_id))];
                        item.level_ids = tableData.map((a) => a.level_id);
                        item.organization_id = user?.organization?.organization_id;
                        const response = await apiRequest('post', '/department/create-from-template', item);
                        if (response.data) {
                            handleClose();
                            showNotification('The departments have been successfully added to the selected levels.', 'success');
                        }
                    } else if (innerLabel === 'Room') {
                        item.room_template_ids = selectedData.map((a) => a.room_template_id);
                        item.department_ids = tableData.map((a) => a.department_id);
                        item.organization_id = user?.organization?.organization_id;
                        const response = await apiRequest('post', '/project-room/create-from-template', item);
                        if (response.data) {
                            handleClose();
                            showNotification('The rooms have been successfully added to the selected departments.', 'success');
                        }
                    }
                } else {
                    item.room_data = JSON.stringify(
                        tableData?.map((a) => ({
                          room_id: a.room_id,
                          quantity: a.quantity || 1
                        }))
                    );
                    const response = await apiRequest('post', '/project-item/from-catalog', item);
                    if (response.data) {
                        handleClose();
                        showNotification('The item has been successfully added to the selected rooms', 'success');
                    }
                }
            } catch (error) {
                setDataLoading(false);
                showNotification(error?.response?.data.error || error.message, 'error');
            }
        } else {
            showNotification('Please select destination before proceed', 'error');
        }
    }

    const handleNext = () => {
        if (activeStep === 0 && tableData.length === 0) {
            showNotification('Please select destination', 'error');
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }

    useEffect(() => {
        if (projectData && !fromTemplate) {
            setItem((prevData) => ({
                ...prevData,
                organization_id: user?.organization?.organization_id,
                created_by: user?.user_id,
                scope: Scope[0]?.value,
                status: ItemStatus[0]?.value,
                stage: ActionStage[0]?.value,
                tax: projectData?.tax_rate,
                funding_source: projectData?.funding_source,
                project_id: projectData?.project_id
            }));
            if (selectedData?.length > 0) {
                setItem((prevData) => {
                    const selectedProductData = selectedData[0];
                    const filteredProductData = Object.keys(selectedProductData).reduce((acc, key) => {
                        if (selectedProductData[key] != null) {
                            acc[key] = selectedProductData[key];
                        }
                        return acc;
                    }, {});
                    return {
                        ...prevData,
                        unit_price: filteredProductData?.list_price,
                        product_data: {
                            furnish_responsibility: filteredProductData?.furnish_responsibility,
                            install_responsibility: filteredProductData?.install_responsibility,
                            architectural_code: filteredProductData?.architectural_code,
                            vendor_id: filteredProductData?.vendor_id,
                            vendor: {
                                name: filteredProductData?.vendor?.name
                            }
                        },
                        product_id: filteredProductData?.product_id,
                    };
                });

            }
        }
    }, [projectData]);

    return (
        <Drawer
            anchor="bottom"
            open={catalogOpen}
            sx={{
                '& .MuiDrawer-paper': {
                    height: '88%',
                }
            }}
        >
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <DemoBox1>
                <Typography variant='body1' style={{ fontWeight: 'bold' }}>Add Item To Project</Typography>
                <Box>
                    {activeStep > 0 && !fromTemplate && (
                        <Button variant='outlined' size="small" onClick={() => handleBack()} style={{ marginRight: 5 }}>
                            Back
                        </Button>
                    )}
                    {activeStep < 1 && !fromTemplate && (
                        <Button variant='contained' size="small" onClick={() => handleNext()}>
                            Next
                        </Button>
                    )}
                    {(activeStep === 1 || fromTemplate) && (
                        <Button variant='contained' size="small" onClick={() => handleSubmit()}>
                            Save
                        </Button>
                    )}
                    <IconButton onClick={() => handleClose()}>
                        <ClearIcon />
                    </IconButton>
                </Box>
            </DemoBox1>
            <Divider />
            {!fromTemplate && (
                <Box sx={{ width: '100%', padding: activeStep !== 2 ? '10px' : '5px 0px 0px 0px' }}>
                    <Stepper activeStep={activeStep} style={{ marginBottom: '5px' }}>
                        {steps.map((label, index) => {
                            const stepProps = {};
                            const labelProps = {};
                            return (
                                <Step key={label} {...stepProps}>
                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                        })}
                    </Stepper>
                    <Divider />
                </Box>)}
            {(activeStep === 1 && !fromTemplate) && (
                <ProductDetails
                    projectData={projectData}
                    selectedProduct={selectedData}
                    item={item}
                    setItem={setItem}
                />
            )}
            {(activeStep === 0 || fromTemplate) && (
                <CommonDestination
                    projectData={projectData}
                    setProjectData={setProjectData}
                    tableData={tableData}
                    setTableData={setTableData}
                    fromCatalog
                    innerLabel={innerLabel}
                />
            )}
        </Drawer>
    )
}

export default AddItemInProject;